import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Planning next week's directive on your evening off, unpaid", "Staring at a blank page with no idea what to bring to Monday's client", 'Books full of ice-breakers, and nothing to ask once the art is done', 'Running the same mandala and safe-place drawing on repeat', 'Not sure what to do with yourself while the client is drawing', 'A teen who says "this is childish" and an adult who says "I can\'t draw"', "Activities that need supplies your budget doesn't cover", 'Moving to telehealth and losing the art table'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-lav-soft" data-id="element-211" data-mp="1bqmakv01sprl">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-212" data-mp="17p10tiit8rlm">
        <div className="text-center" data-id="element-213" data-mp="363vk2mslgb9u">
          <p className="text-sm font-semibold text-lav-deep" data-id="element-214" data-mp="362u88g3r7kr2">The part nobody schedules</p>
          <h2 id="pain-heading" className="mt-3 font-display text-3xl font-semibold leading-tight text-navy sm:text-4xl md:text-5xl" data-id="element-215" data-mp="3220jxlmeg3xn">
            If you use art in session, you know at least{' '}
            <span className="wash-text" data-id="element-216" data-mp="3l9rafcm5vbw8">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-217" data-mp="379q8dtu5tyf6">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl bg-white px-4 py-4 text-sm text-navy shadow-card" data-id="element-218" data-mp="3baa9f8hutm6l">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-rose-soft" data-id="element-219" data-mp="7s8i3fws9iq1">
                <XIcon className="h-3 w-3 text-rose-deep" aria-hidden="true" data-id="element-220" data-mp="3q6hnrs6kztdy" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-medium leading-tight text-lav-deep sm:text-3xl" data-id="element-221" data-mp="lsjaindqr5db">
          How many more evenings do you want to spend building sessions from
          scratch?
        </p>
      </div>
    </section>;
}